<template>
  <div class="cr-order-detail">
    <div v-if="orderLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
    <div v-if="orderError" class="mc-error">{{ orderError }}</div>
    <div v-if="orderLoaded" class="cr-container">
      <div class="cr-order-detail__summary cr-summary">
        <div class="cr-summary__header">
          <div class="cr-summary__status">
            <div class="cr-status">
              {{ order.status }}
            </div>
            <div class="cr-status" :class="'cr-status--'+(order.pay?'blue':'yellow')">
              Оплачен
            </div>
          </div>
          <div class="cr-summary__text">
            {{ order.date_create }}
          </div>
        </div>
        <dl class="cr-summary__list">
          <div class="cr-summary__item cr-summary__item--strong">
            <dt class="cr-summary__term">
              Итого
            </dt>
            <dd class="cr-summary__value">
              {{ formatPrice(order.sum) }} ₽
            </dd>
          </div>
          <div v-if="order.base_sum > order.sum" class="cr-summary__item">
            <dt class="cr-summary__term">
              Итого без скидки
            </dt>
            <dd class="cr-summary__value">
              {{ order.base_sum }} ₽
            </dd>
          </div>
          <div v-if="order.base_sum > order.sum" class="cr-summary__item">
            <dt class="cr-summary__term">
              Скидка
            </dt>
            <dd class="cr-summary__value">
              {{ formatPrice(order.base_sum - order.sum) }} ₽
            </dd>
          </div>
          <div class="cr-summary__item">
            <dt class="cr-summary__term">
              Наименований
            </dt>
            <dd class="cr-summary__value">
              {{ order.quantity }}
            </dd>
          </div>
        </dl>
        <div v-if="order.billRequest && !billRequestResult" class="cr-summary__bottom">
          <button @click="billRequest" class="cr-button cr-button--light" type="button">
                            <span class="cr-button__text">
                                Запросить счет
                            </span>
          </button>
        </div>
        <div v-if="isSubmitting" class="mc-loader"><span class="mc-loader__circle"></span></div>
        <div v-if="billRequestResult && !order.props.BILL" class="cr-summary__message">
          Счет запрошен
        </div>
        <div v-if="serverError" class="cr-detail-card__message cr-message cr-message--error" v-html="serverError"></div>


        <div v-if="order.props.BILL" class="cr-summary__message">
          Счет доступен для скачивания
        </div>
        <div v-if="order.props.BILL" class="cr-summary__bottom cr-summary__bottom--row">
          <a :href="order.props.BILL" target="_blank" class="cr-button cr-button--light">
                            <span class="cr-button__text">
                                Скачать счет
                            </span>
          </a>
          <button v-if="shareSupported" @click="shareOrder" class="cr-square-button" type="button">
            <svg class="cr-square-button__icon" width="25" height="25" viewBox="0 0 26 26">
              <use xlink:href="/assets/img/svg/sprite.svg#icon-share"></use>
            </svg>
          </button>


        </div>
      </div>
      <div class="cr-order-detail__history">
        <div class="cr-order-detail__history-title">
          Ваш заказ №{{ order.number }}
        </div>
        <ul class="cr-order-detail__history-list">
          <li v-for="item in order.status_path" class="cr-order-detail__history-item">
            <div class="cr-nameplate" :class="{'cr-nameplate--done': item.checked}">
              {{ item.name }}
            </div>
          </li>
        </ul>
      </div>
      <div class="cr-order-detail__summary cr-summary">
        <dl class="cr-summary__description cr-description">
          <div class="cr-description__item">
            <dt class="cr-description__term">
              Адрес
            </dt>
            <dd class="cr-description__definition">
              {{ order.props.ADDRESS }}
            </dd>
          </div>
          <div v-if="order.comments" class="cr-description__item">
            <dt class="cr-description__term">
              Комментарий
            </dt>
            <dd class="cr-description__definition">
              {{ order.comments }}
            </dd>
          </div>
        </dl>
      </div>
      <div class="cr-order-detail__section">
        <div class="cr-order-detail__section-title">
          Товары в заказе
        </div>
        <ul class="cr-order-detail__list">
          <li v-for="item in order.items" class="cr-order-detail__item">
            <ProductItem :product="item.product" :isOrder="true"></ProductItem>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import product from "@/mixin/product.vue";
import {mapActions, mapGetters} from "vuex";
import ProductItem from "@/views/components/ProductItem.vue";
import axios from "axios";
import scrollToError from "@/mixin/scrollToError.vue";


export default {
  data: () => ({
    billRequestResult: false,
    isSubmitting: null,
    serverError: null

  }),
  mixins: [product, scrollToError],
  created() {
    this.fetchOrder(this.$route.params.id);
  },
  computed: {
    ...mapGetters('order_detail', [
      'order',
      'orderLoading',
      'orderError',
      'orderLoaded',
    ]),
    shareSupported() {
      return navigator.share
    }
  },
  methods: {
    ...mapActions('order_detail', [
      'fetchOrder'
    ]),
    async billRequest() {
      if (this.isSubmitting === true)
        return;
      this.isSubmitting = true;
      this.serverError = null;

      const formDataToSubmit = {
        id: this.order.id
      };

      try {
        const response = await axios.post('/api/order/bill/', formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = 'Ошибка сервера.';
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }

        this.billRequestResult = true;
        this.fetchOrder(this.$route.params.id);


      } catch (error) {
        this.serverError = error;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },
    // Метод для шаринга
    async shareOrder() {
      // Проверяем поддержку Web Share API
      if (!navigator.share) {
        console.log('Web Share API не поддерживается в этом браузере');
        return;
      }

      // Формируем данные для шаринга
      const shareData = {
        title: `Счет на оплату. Заказ №${this.order.number}`,
        text: `Счет на оплату`,
        url: this.order.props.BILL
      };

      try {
        // Вызываем нативный диалог шаринга
        await navigator.share(shareData);
        console.log('Успешно поделились');
      } catch (error) {
        // Если пользователь просто закрыл окно шаринга, не показываем ошибку
        if (error.name !== 'AbortError') {
          console.error('Ошибка при попытке поделиться:', error);
        }
      }
    }

  },
  components: {
    ProductItem

  }
}
</script>
